import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const areaURL = `api/v1/location-app/area`;

//obtaining the paginated data
export const getArea = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${areaURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllArea = () => axiosInstance.get(`${areaURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageArea = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${areaURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

export const getAreaById = (id) => axiosInstance.get(`${areaURL}/retrieve/${id}`);

//creating function
export const createArea = (body) => axiosInstance.post(`${areaURL}/create`, body);
//updating function
export const updateArea = (id, body) => axiosInstance.patch(`${areaURL}/update/${id}`, body);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${areaURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataAreaName = (e, cancelToken) =>
  axiosInstance.get(`${areaURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
